// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DashOutlinedSvg from "@fishx/icons-svg/es/asn/DashOutlined";
import FishxIcon from '../components/FishxIcon';

var DashOutlined = function DashOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DashOutlinedSvg
  }));
};

DashOutlined.displayName = 'DashOutlined';
export default React.forwardRef(DashOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DashOutlined.js
// module id = 2363
// module chunks = 0